import { devSecrets } from './secrets.dev.local';

export const environment = {
  production: false,
  useAuth0: false,
  vulcan: {
    url: 'https://k5uvsc1ut3.execute-api.us-east-1.amazonaws.com/prod/',
  },
  botConfig: {
    url: 'https://68wvxnrx4a.execute-api.us-east-1.amazonaws.com/dev/bot-configuration/',
    latestVersion: 4,
  },
  dumbledore: {
    url: 'https://dumbledore-dev.testenv.carlabs-x.com/',
  },
  bach: {
    url: 'https://bach-dev.testenv.carlabs-x.com/',
  },
  // credentials for dev database
  firebase: {
    apiKey: 'AIzaSyAmwelCnYp0gOVOeHYL7BpIeDKKInRbMCA',
    authDomain: 'brain-ui-v1-dev.firebaseapp.com',
    databaseURL: 'https://brain-ui-v1-dev.firebaseio.com',
    projectId: 'brain-ui-v1-dev',
    storageBucket: 'brain-ui-v1-dev.appspot.com',
    messagingSenderId: '177764226367',
    appId: '1:177764226367:web:0894bc9cb5ab0c575fef8a',
    measurementId: 'G-9GR7LVPN4P',
  },
  apiGatewayAnalytics: {
    url: 'https://hlyrwwjqal.execute-api.us-east-1.amazonaws.com/',
  },
  analyticsWebSocket: {
    url: 'wss://0vtqn8e2ph.execute-api.us-east-1.amazonaws.com/dev/',
  },
  platformApi: {
    url: 'https://platformapi-dev.testenv.carlabs-x.com',
  },
  domain: 'dev-d8wrdqvexeqghnvi.us.auth0.com',
  clientId: 'w7DA97ftw6eQxk1cHDpCMgnEVoemoXHV',
  authSecrets: devSecrets,
  knowledgeBankAPIKey:
    'gAAAAABntMrlxSLDGRji-3t0rWasxqupVm1vo61Z3iUC9kqD4IWaWxijhMqR4ELgP0pjXQVXA5kwtKd6gufaoeMt1iStNCKinlmt9F2msNy9hqCAo_KzbPbScubwtMejRUSimuXEderRXU831bbNd-r37Blpto_bu6_r9APWQcLnyiMCnUhFOhkqjgDnidZs8iB7RNpgIiatRPxcF53yRetPKRqvxBWTdT2S7dQFQY09Cc_HhnSh6lvB2i7kD5ooF2hZCEF7tyKg',
  voiceAiDashboardFiltersTTL: 15, // 15 minutes
};
